import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, useMap, useMapEvents } from 'react-leaflet';
import L from 'leaflet';

// Fix for default Leaflet icon issue in React/Webpack/Vite
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

let DefaultIcon = L.icon({
    iconUrl: markerIcon,
    iconRetinaUrl: markerIcon2x,
    shadowUrl: markerShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
});

L.Marker.prototype.options.icon = DefaultIcon;

/**
 * Component to update map center when props change
 */
function ChangeView({ center, zoom }) {
    const map = useMap();
    useEffect(() => {
        if (center && center[0] && center[1]) {
            map.setView(center, zoom);
        }
    }, [center, zoom, map]);
    return null;
}

/**
 * Component to handle map clicks
 */
function MapEvents({ onMapClick, isEditable }) {
    useMapEvents({
        click(e) {
            if (isEditable && onMapClick) {
                onMapClick(e.latlng.lat, e.latlng.lng);
            }
        },
    });
    return null;
}

export default function LocationMap({ 
    lat, 
    lng, 
    onLocationSelect, 
    isEditable = false,
    zoom = 13,
    height = "300px"
}) {
    // Default center if no coordinates provided (Dresden as fallback)
    const defaultCenter = [51.0504, 13.7373];
    const center = (lat && lng) ? [lat, lng] : defaultCenter;

    const handleMapClick = (newLat, newLng) => {
        if (onLocationSelect) {
            onLocationSelect(newLat, newLng);
        }
    };

    return (
        <div style={{ height, width: '100%', borderRadius: '1rem', overflow: 'hidden' }} className="border border-gray-100 dark:border-gray-800 shadow-inner">
            <MapContainer 
                center={center} 
                zoom={zoom} 
                style={{ height: '100%', width: '100%' }}
                scrollWheelZoom={false}
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
                    url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
                />
                
                <ChangeView center={center} zoom={zoom} />
                <MapEvents onMapClick={handleMapClick} isEditable={isEditable} />

                {(lat && lng) && (
                    <Marker position={[lat, lng]} />
                )}
            </MapContainer>
        </div>
    );
}
